import React from "react";

const LOOM_EMBED = "https://www.loom.com/embed/8db77465d7704bd298f892ec519323af";

export function CustomizationHelpVideo({ styles }) {
  return (
    <section style={styles.helpSection}>
      <h3 style={styles.helpTitle}>Vídeo de ajuda</h3>
      <div style={styles.helpIframeWrapper}>
        <iframe
          title="Como usar Customização"
          src={LOOM_EMBED}
          style={styles.helpIframe}
          frameBorder="0"
          allow="fullscreen"
          allowFullScreen
        />
      </div>
    </section>
  );
}
